var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-tab-item', {
    staticClass: "fill-height pa-16",
    attrs: {
      "value": _vm.TABS.BASIC.value
    }
  }, [_c('v-layout', {
    staticClass: "h-100 mx-auto",
    staticStyle: {
      "max-width": "1224px"
    },
    attrs: {
      "column": "",
      "justify-center": ""
    }
  }, [_c('v-sheet', {
    staticClass: "scroll-primary pr-10",
    staticStyle: {
      "flex": "1 1 auto",
      "overflow-x": "hidden",
      "overflow-y": "auto"
    }
  }, [_c('div', {
    staticClass: "mb-20 mb-lg-40"
  }, [_c('vertical-form-table', _vm._b({
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.form,
      callback: function ($$v) {
        _vm.form = $$v;
      },
      expression: "form"
    }
  }, 'vertical-form-table', {
    items: _vm.items,
    class: 'flex-grow-1'
  }, false)), _c('basic-convert', _vm._g(_vm._b({
    model: {
      value: _vm.form,
      callback: function ($$v) {
        _vm.form = $$v;
      },
      expression: "form"
    }
  }, 'basic-convert', {
    loading: _vm.loading
  }, false), {
    setLoading: _vm.setLoading,
    input: _vm.emit
  }))], 1)]), _c('div', {
    staticClass: "v-btn-group flex-wrap mt-16"
  }, [_c('v-btn', _vm._b({
    staticClass: "min-w-140px min-w-lg-160px",
    attrs: {
      "outlined": "",
      "color": "grey-d"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('exit');
      }
    }
  }, 'v-btn', {
    loading: _vm.loading
  }, false), [_c('span', {
    staticClass: "grey-6--text"
  }, [_vm._v("취소")])]), _c('v-btn', _vm._b({
    staticClass: "min-w-140px min-w-lg-160px",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.next
    }
  }, 'v-btn', {
    loading: _vm.loading
  }, false), [_c('span', [_vm._v(" 다음 단계 ")]), _c('v-icon', [_vm._v("mdi-chevron-right")])], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }